type Trueified = true | null | readonly Trueified[] | { readonly [key: string]: Trueified };

function replaceAllValuesWithTrue(input: unknown): Trueified {
	if (input === null || input === undefined) {
		return null;
	}

	if (Array.isArray(input)) {
		return input.map(replaceAllValuesWithTrue);
	}

	if (typeof input === 'object') {
		return Object.fromEntries(Object.entries(input).map(([key, value]) => [key, replaceAllValuesWithTrue(value)]));
	}

	return true;
}

export function replaceAllValuesWithTrueRecord(
	input: Readonly<Record<string, unknown>>,
): Readonly<Record<string, unknown>> {
	const result: Record<string, unknown> = {};

	for (const [key, value] of Object.entries(input)) {
		result[key] = replaceAllValuesWithTrue(value);
	}

	return result;
}
